import { cn } from '@cocoonspace/ui/lib/utils'
import { ArrowDownIcon } from 'lucide-react'
import { AnimatePresence, motion } from 'motion/react'

type HiddenEventsBadgeProps = {
	count: number
	onClick: () => void
}

export const HiddenEventsBadge = ({
	count,
	onClick,
}: HiddenEventsBadgeProps) => (
	<AnimatePresence>
		{count > 0 && (
			<motion.div
				initial={{ opacity: 0, y: 4 }}
				animate={{ opacity: 1, y: 0 }}
				exit={{ opacity: 0, y: 4 }}
				className='pointer-events-none absolute right-0 bottom-0 left-0 flex justify-center pb-2'
			>
				<motion.button
					type='button'
					animate={{ scale: 1 }}
					className={cn(
						'pointer-events-auto',
						'flex items-center gap-1',
						'rounded-full',
						'bg-primary',
						'px-3',
						'py-1',
						'font-medium',
						'text-[11px]',
						'text-primary-foreground',
						'shadow-md',
					)}
					exit={{ scale: 0.95 }}
					initial={{ scale: 0.95 }}
					layout
					onClick={onClick}
				>
					+{count} <ArrowDownIcon className='size-3!' />
				</motion.button>
			</motion.div>
		)}
	</AnimatePresence>
)
